<template>
  <div style="width: 100%">
    <v-data-table
      :headers="headers"
      :items="items"
      :hide-default-header="empty"
      :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
      disable-pagination
      hide-default-footer
      dense
      :show-select="bulkMode"
      v-model="selected"
      item-key="item.string"
      style="white-space: nowrap"
    >
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
          <v-switch
            v-model="anyof"
            label="AND/OR"
            color="success"
            hide-details
          />
        </v-toolbar>

        <div v-if="showBulk && !readonly && (items.length >= 2)" class="d-flex pl-4 pb-1 align-center">
          <v-checkbox
            v-model="bulkMode"
            hide-details
            :disabled="!items.length"
            class="mt-0 pt-0"
          />

          <v-btn
            x-small
            class="ma-2 white--text"
            color="red"
            :disabled="!bulkMode || !deletableCountLocal"
            @click="bulkRemove"
          >
            Bulk Delete
            <span v-if="deletableCountLocal"> ({{ deletableCountLocal }})</span>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.amount="{item}">
        <div>{{ item.amount > 0 ? item.amount : "-" }}</div>
      </template>
      <template v-slot:item.strict="{item}">
        <div>{{ item.strict ? "ON" : "OFF" }}</div>
      </template>
      <template v-if="!readonly" v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-guard-rule-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {GuardRule} from "@/modules/redactor/models/guard/GuardRule";
import RGuardRuleDialog from "@/modules/redactor/views/guard/r-guard-rule-dialog";

export default {
  name: "r-guard-rules",
  components: {RGuardRuleDialog},
  props: {
    title: VueTypes.string.isRequired,
    items: VueTypes.arrayOf(GuardRule).isRequired,
    anyof: VueTypes.bool.def(false).isRequired,
    readonly: VueTypes.bool.def(false),
    showBulk: VueTypes.bool.def(true)
  },
  data: () => ({
    headers: [
      {text: 'Name', value: 'item.string'},
      {text: 'Amount', value: 'amount'},
      {text: 'Strict', value: 'strict'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    selected: [],
    bulkMode: false,
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    },

    deletableCountLocal() {
      return this.selected.length;
    },
  },
  methods: {
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy())
        .then((data) => {
          this.items.push(data);
        }).catch(() => {
      });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null, this.items)
        .then((data) => {
          this.items.push(data);
        }).catch(() => {
      });
    },

    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone(), this.items, item)
        .then((data) => {
          const index = this.items.indexOf(item);
          this.items.splice(index, 1, data);
        }).catch(() => {
      });
    },

    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },

    bulkRemove() {
      if (!this.selected.length) return;

      this.$confirm("Are you sure you want to delete selected items?")
        .then(() => {
          this.selected.forEach(item => {
            const index = this.items.indexOf(item);
            if (index !== -1) {
              this.items.splice(index, 1);
            }
          });
          this.selected = [];
          this.bulkMode = false;
        })
        .catch(() => {});
    }
  },
  watch: {
    anyof: function (value) {
      this.$emit("update:anyof", value);
    },

    items(newItems) {
      this.selected = this.selected.filter(v => newItems.includes(v));
    },

    bulkMode(value) {
      if (!value) {
        this.selected = [];
      }
    }
  }
}
</script>